const AB_MOBILE_CTA_SESSION_KEY = 'IGNORE_AB_CTA'

type AB_MOBILE_CTA_SESSION_KEY_TYPE = Record<string, boolean>

class ABMobileCTA {
  public getCTASession = (): AB_MOBILE_CTA_SESSION_KEY_TYPE => {
    try {
      return JSON.parse(
        sessionStorage.getItem(AB_MOBILE_CTA_SESSION_KEY) ?? '{}'
      )
    } catch {
      return {}
    }
  }

  public isIgnoredForDesign = (designId: string): boolean => {
    const abCtaData = this.getCTASession()
    return designId in abCtaData
  }

  public setIgnoreCTAForDesign = (designId: string): void => {
    const abCtaData = this.getCTASession()
    abCtaData[designId] = true
    sessionStorage.setItem(AB_MOBILE_CTA_SESSION_KEY, JSON.stringify(abCtaData))
  }
}

export const abMobileCTA = new ABMobileCTA()
